<template>
  <div class="moviesorderApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:10px"></div>
    <div class="moviesInfo">
      <div class="infoTop">
        <el-image style="width: 100px; height: 120px" :src="setMovies.orderPicUrl" fit="cover"></el-image>
        <div class="con">
          <h2>{{chooseSeats.movieName}}</h2>
          <p>{{chooseSeats.playTime}} 开场</p>
          <p>{{chooseSeats.hallName}}（{{chooseSeats.edition}}）</p>
          <p><span v-for="(item,i) in chooseSeats.seat" style="margin-right:10px">{{item.name}}</span></p>
          <p>共{{chooseSeats.num}}张 原价{{chooseSeats.totalOriginAmount}}元</p>
        </div>
      </div>
      <div class="infoBottom">
        <h2>影院</h2>
        <p>{{chooseSeats.cinemaName}}</p>
      </div>
      <div class="expires"><i class="el-icon-time"></i>{{timerMsg}}</div>
    </div>

    <div class="moviesCard">
      <div class="item-list" v-if="total > 0" @click="getDrawer">
        <span>优惠劵 <font>(最高抵扣30元，账户余额当现金用)</font></span>
        <a>
          <font :class="usePrice<=0 ? 'use':'puse'" v-if="total > 0">{{usePrice <= 0 ? totalCoupon+'张可用' : '-￥' +usePrice}}</font>
          <font v-if="total <= 0">暂无抵用劵</font>
          <i class="el-icon-arrow-right"></i>
        </a>
      </div>
      <div class="item-list" v-if="total <= 0" @click="$router.push('moviescoupon')">
        <span>优惠劵 <font>(最高可抵扣30元)</font></span>
        <a>
          <font style="color:#FE506A">领取优惠券</font>
          <i class="el-icon-arrow-right" style="color:#FE506A"></i>
        </a>
      </div>
      <div class="item-list">
        <span>手机号码</span>
        <a><input type="number" v-model="mobile" placeholder="请输入手机号" /><i class="el-icon-arrow-right"></i></a>
      </div>
    </div>
    <div>
    </div>
    <div class="noty">
      <!--<h2 v-if="setScenic.length > 0">推荐游玩景区</h2>
      <ul v-if="setScenic.length > 0">
        <li v-for="(item,i) in setScenic" @click="chooseScenic(item.scenic_id,item.price)">
          <div class="right">
            <el-image style="width: 70px; height: 60px;float:left;border-radius:6px;" :src="baseUrl+item.img" fit="cover"></el-image>
            <div class="title">
              <h3>{{item.title}}</h3>
              <span>￥{{item.price}}</span>
            </div>
          </div>
          <i :class="scenicId == item.scenic_id ? 'el-icon-success curt' : 'el-icon-success'"></i>
        </li>
      </ul>-->
      <h2>购票须知</h2>
      <p>购买成功后20分钟以内为您出票,此电影票为特价电影票,请确认时间和场次无误,<font>出票成功后将无法退票和改签。</font>下单即代表您同意。出票成功后会有短信通知，请注意查收！</p>
    </div>

    <div style="height:80px"></div>
    <div class="orderBtn">
      <span>{{(((chooseSeats.totalOriginAmount - usePrice) <=0 ? '0.0' : (chooseSeats.totalOriginAmount - usePrice))*1 + (scenicPrice*1)).toFixed(2)}}元 <font>{{(chooseSeats.totalOriginAmount*1+scenicPrice*1).toFixed(2)}}元</font></span>
      <a @click="payment">确认付款</a>
    </div>



    <el-drawer title="优惠劵(最高抵扣30元)" :visible.sync="drawer" size="50%" :direction="direction">
      <ul>
        <li v-for="(item,i) in setCoupon" v-if="item.total - item.use > 0">
          <div class="cardlist">
            <div class="mCard" @click="chooseCard(i,1,30)">
              <span>{{item.title}}</span>
              <font>已用<b>{{item.use}}</b>次、剩余<b>{{item.total - item.use}}</b>次、可抵扣<b>30</b>元</font>
              <i :class="'el-icon-success'+(types == i && smc == 1 ? ' yesChoose' : '')"></i>
            </div>
          </div>
        </li>
        <li  v-if="setWallet > 0">
          <div class="cardlist">
            <div class="mCard" @click="chooseCard(0,3,(setWallet>=chooseSeats.totalOriginAmount ? chooseSeats.totalOriginAmount : setWallet))">
              <span>余额抵扣</span>
              <font>余额{{setWallet}}元，可抵扣<b>{{setWallet>=chooseSeats.totalOriginAmount ? chooseSeats.totalOriginAmount : setWallet}}</b>元</font>
              <i :class="'el-icon-success'+(smc == 3 ? ' yesChoose' : '')"></i>
            </div>
          </div>
        </li>
        <li v-for="(item,i) in setMovieCoupon" v-if="item.num - item.useNum > 0">
          <div class="cardlist">
            <div class="mCard" @click="chooseCard(i,2,item.price)">
              <span>{{item.title}}</span>
              <font>已用<b>{{item.useNum}}</b>次、剩余<b>{{item.num - item.useNum}}</b>次、可抵扣<b>{{item.price}}</b>元</font>
              <i :class="'el-icon-success'+(types == i && smc == 2 ? ' yesChoose' : '')"></i>
            </div>
          </div>
        </li>
      </ul>
      <div class="cardFoot" v-if="types !=-1" @click="saveCard">确认</div>
    </el-drawer>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        drawer:false,
        direction: 'btt',
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setMovies:[],
        chooseSeats:[],
        setCoupon:[],
        setMovieCoupon:[],
        setScenic:[],
        maxtime:300,
        timerMsg:'5:00',
        timer:'',
        useNum:0,
        cardId:0,
        order_id:0,
        types:-1,
        smc:-1,
        choosePrice:0,
        usePrice:0,
        mobile:'',
        total:0,
        coupon_id:0,
        totalCoupon:0,

        scenicId:0,
        scenicPrice:0,
        setWallet:0
      };
    },
    beforeMount() {
      let Base64 = require('js-base64').Base64
      this.baseUrl = this.$host;
      var str = this.$route.query.str;
      this.setMovies = JSON.parse(Base64.decode(str));
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/moviesdetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getCoupon();
        this.getMovieCoupon();
        this.getWallet();
        this.getScenic();
        this.getChooseSeats();
      }
      this.countDown();
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getLocalTime:function(nS) {
        var str = new Date(parseInt(nS)).toLocaleString();
        return str.substr(0, str.length - 8)    
      },
      chooseScenic:function(id,price){
        if(id == this.scenicId){
          this.scenicId = '';
          this.scenicPrice = 0
        }else{
          this.scenicId = id;
          this.scenicPrice = price
        }
      },

      getChooseSeats:function(){
        var that = this;
        var arr = that.setMovies
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/chooseSeats',
          data:{
            showId:arr[0]
          },
          dataType:'json',
          success:function(data){
            var totalOriginAmount = 0;
            for(var i =0;i<arr[1].length;i++){
              totalOriginAmount += arr[1][i].salePrice
            }
            data.data['totalOriginAmount'] = totalOriginAmount.toFixed(2);
            data.data['seat'] = arr[1];
            data.data['num'] = arr[1].length;
            that.chooseSeats = data.data;
            console.log(that.chooseSeats)
            that.fullscreenLoading = false;
          }
        })
      },
      getScenic:function(){
        var that = this;
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/getScenic',
          data:{
            c:cCode.cityName
          },
          dataType:'json',
          success:function(data){
            that.setScenic = data.data;
            if(data.data.length > 0){
              //that.scenicId = data.data[0].scenic_id;
              //that.scenicPrice = data.data[0].price;
            }
            that.fullscreenLoading = false;
          }
        })
      },
      getMovieCoupon:function(){
        var that = this;
        var u = JSON.parse(localStorage.getItem('userjwt'));
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/movieCoupon',
          data:{
            user_id:u.id,
          },
          dataType:'json',
          success:function(data){
            that.setMovieCoupon = data.data;
            var arr = data.data;
            var total = that.total;
            var use = 0;
            for(var i=0;i<arr.length;i++){
              total = total + (arr[i].num - arr[i].useNum)
              if(arr[i].num - arr[i].useNum > 0){
                use += 1;
              }
            }
            that.total = total;
            that.totalCoupon = that.totalCoupon + use
            that.fullscreenLoading = false;
          }
        })
      },
      getWallet:function(){
        var that = this;
        var u = JSON.parse(localStorage.getItem('userjwt'));
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/wallet',
          data:{
            user_id:u.id,
          },
          dataType:'json',
          success:function(data){
            that.setWallet = data.data;
            if(data.data > 0){
              var totalCoupon = that.totalCoupon;
              that.totalCoupon = totalCoupon+1;
            }
            that.fullscreenLoading = false;
          }
        })
      },
      getCoupon:function(){
        var that = this;
        var u = JSON.parse(localStorage.getItem('userjwt'));
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/getCoupon',
          data:{
            user_id:u.id,
          },
          dataType:'json',
          success:function(data){
            that.setCoupon = data.data;
            var arr = data.data;
            var total = that.total;
            var use = 0;
            for(var i=0;i<arr.length;i++){
              total = total + (arr[i].total - arr[i].use)
              if(arr[i].total - arr[i].use > 0){
                use += 1;
              }
            }
            that.total = total;
            that.totalCoupon = that.totalCoupon + use
            that.fullscreenLoading = false;
          }
        })
      },
      countDown:function(){
        var that = this;
        that.timer = setInterval(function (){
          that.maxtime--
          var minutes = Math.floor(that.maxtime / 60);
          var seconds = Math.floor(that.maxtime % 60);
          var msg = minutes + ":"+(seconds < 10 ? '0'+seconds : seconds);
          that.timerMsg = msg

          if(that.maxtime <= 0){
            clearInterval(that.timer);
            that.$router.push('index')
          }
        },1000);
      },
      getDrawer:function(){
        this.types = -1;
        this.drawer = true;
      },
      chooseCard:function(inx,smc,price){
        this.types = inx;
        this.smc = smc;
        this.choosePrice = price;
      },
      saveCard:function(){
        var i = this.types;
        this.usePrice = this.choosePrice;
        if(this.smc == 1){
          this.cardId = this.setCoupon[i].cardId;
          this.order_id = this.setCoupon[i].id;
        }
        if(this.smc == 2){
          this.coupon_id = this.setMovieCoupon[i].id;
        }
        this.drawer = false;
      },
      //确认付款
      payment:function(){
        var that = this;
        if(that.mobile == ''){
          that.$alert('请输入手机号', '提示');
          return false;
        }
        var u = JSON.parse(localStorage.getItem('userjwt'));
        var arr = that.chooseSeats;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/saveOrder',
          data:{
            user_id:u.id,
            cinemaId:arr.cinemaId,
            movieId:arr.movieId,
            showId:arr.playItemId,
            seatIds:JSON.stringify(arr.seat),
            mobile:that.mobile,
            usePrice:that.usePrice,
            cardId:that.cardId,
            orderId:that.order_id,
            coupon_id:that.coupon_id,
            types:that.smc,
            price:arr.totalOriginAmount,
            scenicId:that.scenicId,
            scenicPrice:that.scenicPrice
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              if(((that.chooseSeats.totalOriginAmount+that.scenicPrice) - that.usePrice) <= 0){
                that.$router.push('msorder');
              }else{
                that.jsApiCall(data.data);
              }
            }else{
              that.$alert(data.message, '提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },

      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/msorder";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .moviesorderApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .moviesorderApp .moviesInfo{
    background:#fff;
    border-radius:8px;
    width:94%;
    margin:0 auto 15px auto;
    padding-bottom:15px;
    position:relative;
  }
  .moviesorderApp .moviesInfo .expires{
    position:absolute;
    top:35%;
    right:4%;
    font-size:15px;
    color:#FE506A;
    transform: translateY(-50%);
  }
  .moviesorderApp .moviesInfo .expires i{
    margin-right:2px;
  }
  .moviesorderApp .infoTop .el-image{
    float:left;
    margin:15px 10px 15px 15px;
  }
  .moviesorderApp .infoTop .el-image img{
    border-radius:6px;
  }
  .moviesorderApp .infoTop:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .moviesorderApp .infoTop .con{
    float:left;
    width:calc(100% - 130px);
    margin-top:15px;
  }
  .moviesorderApp .infoTop .con h2{
    font-size:18px;
  }
  .moviesorderApp .infoTop .con p{
    font-size:14px;
    color:#666;
    padding-top:4px
  }
  .moviesorderApp .infoTop .con p font{
    color:#F8A927;
    font-weight:bold;
  }
  .moviesorderApp .infoBottom{
    padding:0 15px;
  }
  .moviesorderApp .infoBottom h2{
    font-size:18px;
    padding-bottom:10px
  }
  .moviesorderApp .infoBottom h2 a{
    float:right;
    font-size:14px;
    font-weight:500;
    color:#666
  }
  .moviesorderApp .infoBottom p{
    font-size:16px;
    text-align:justify;
    color:#000;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .moviesorderApp .moviesCard{
    background:#fff;
    border-radius:8px;
    width:94%;
    margin:0 auto 15px auto;
  }
  .moviesorderApp .moviesCard .item-list{
    height:60px;
    width:92%;
    margin:0 auto;
    line-height:60px;
    border-bottom:solid 1px #ececec
  }
  .moviesorderApp .moviesCard .item-list:last-child{
    border-bottom:none;
  }
  .moviesorderApp .moviesCard .item-list span{
    font-size:15px;
    color:#000
  }
  .moviesorderApp .moviesCard .item-list span font{
    font-size:10px;
    color:#666
  }
  .moviesorderApp .moviesCard .item-list a{
    float:right;
    font-size:15px;
    color:#666
  }
  .moviesorderApp .moviesCard .item-list a font.use{
    background:#FE506A;
    color:#fff;
    border-radius:8px;
    font-size:13px;
    padding:5px 8px;
    margin-right:5px
  }
  .moviesorderApp .moviesCard .item-list a font.puse{
    color:#FE506A
  }
  .moviesorderApp .moviesCard .item-list a input{
    border:none;
    text-align:right;
    outline:none;
    font-size:15px;
  }

  .moviesorderApp .noty{
    width:94%;
    margin:0 auto;
  }
  .moviesorderApp .noty h2{
    font-size:18px;
    padding-bottom:10px;
  }
  .moviesorderApp .noty ul{
    padding-bottom:10px
  }
  .moviesorderApp .noty li{
    background:#fff;
    height:60px;
    padding:15px 0;
    border-radius: 8px;
    margin-bottom:10px
  }
  .moviesorderApp .noty li i{
    float:left;
    font-size:30px;
    margin:20px 10px 0 5px;
    color:#999
  }
  .moviesorderApp .noty li i.curt{
    color:#FE506A
  }
  .moviesorderApp .noty li .right{
    float:left;
    width:calc(100% - 65px);
    height:60px;
    margin-left:15px
  }
  .moviesorderApp .noty li .right .title{
    float:left;
    width:calc(100% - 80px);
    margin-left:10px;
    height:60px;
    position:relative;
  }
  .moviesorderApp .noty li .right .title h3{
    font-size:18px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }
  .moviesorderApp .noty li .right .title span{
    display:block;
    color:#f00;
    font-size:18px;
    font-weight:bold;
    position:absolute;
    width:100%;
    bottom:0
  }
  .moviesorderApp .noty p{
    font-size:15px;
    line-height:22px;
    color:#999;
    text-align:justify;
  }
  .moviesorderApp .noty p font{
    color:#000;
    text-decoration:underline
  }

  .moviesorderApp .orderBtn{
    position:fixed;
    bottom:0;
    height:65px;
    border-top:solid 1px #ddd;
    width:100%
  }
  .moviesorderApp .orderBtn span{
    float:left;
    margin-left:4%;
    line-height:65px;
    color:#FE506A
  }
  .moviesorderApp .orderBtn span font{
    color:#666;
    text-decoration:line-through;
    padding-left:10px
  }
  .moviesorderApp .orderBtn a{
    float:right;
    width:40%;
    margin-right:4%;
    height:45px;
    line-height:45px;
    background: linear-gradient(90deg, #FE506A, #FE5CA3);
    border-radius: 45px;
    color:#fff;
    text-align:center;
    margin-top:10px;
  }
  .moviesorderApp .el-drawer{
    border-radius:20px 20px 0 0;
  }
  .moviesorderApp .el-drawer__wrapper .el-drawer__header{
    margin-bottom:0;
    padding-bottom:20px;
    border-bottom:solid 1px #ececec
  }
  .moviesorderApp .el-drawer__wrapper .el-drawer__header span{
    font-size:17px !important;
    color:#000 !important;
  }
  .moviesorderApp .el-drawer ul{
    width:92%;
    margin:0 auto;
    padding:35px 0;
  }
  .moviesorderApp .el-drawer ul li{
    margin-bottom:15px;
  }
  .moviesorderApp .el-drawer ul .cardlist{
    background:#ececec;
    border-radius:8px;
  }
  .moviesorderApp .el-drawer ul .mCard{
    height:60px;
    line-height:60px;
    padding:0 15px;
    border-bottom:solid 1px #fff;
    font-size:15px;
  }
  .moviesorderApp .el-drawer ul .mCard span{
    float:left;
    width:30%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .moviesorderApp .el-drawer ul .mCard font{
    font-size:12px;
    padding-left:10px;
    color:#666
  }
  .moviesorderApp .el-drawer ul .mCard font b{
    color:#FE506A;
  }
  .moviesorderApp .el-drawer ul .mCard i{
    float:right;
    font-size:30px;
    line-height:60px;
    color:#ccc
  }
  .moviesorderApp .el-drawer ul .mCard i.yesChoose{
    color:#FE506A;
  }
  .moviesorderApp .el-drawer .cardFoot{
    width:50%;
    height:45px;
    margin:0 auto;
    background:#FE506A;
    text-align:center;
    line-height:45px;
    color:#fff;
    border-radius:45px;
  }
</style>